// eslint-disable-next-line import/prefer-default-export
export function isSorted(arr, key, consecutive, startKey) {
    if (consecutive) {
        if (arr[0] && arr[0][key] !== startKey) { return false; }
        return arr.every((v, i, a) => !i || a[i - 1][key] + 1 === v[key]);
    }
    return arr.every((v, i, a) => !i || a[i - 1][key] < v[key]);
}
